import { selfAxios } from "../../../../axios/selfAxios.js";
async function getGetMarketLineAttributeColumn(params) {
  const { data } = await selfAxios.get(`/bsplatform/commodity/getMarketLineAttributeColumn`, { params });
  return data;
}
export { getGetMarketLineAttributeColumn };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/bsplatform/commodity/getMarketLineAttributeColumn/get.js